import { getApiConfig } from '../utils/apiUtils';
import axios from 'axios';

const API_BASE = '/distribution/api/room-type-inventory';

export const getRoomTypeInventory = async (roomTypeId) => {
  const response = await axios.get(`${API_BASE}/?room_type_id=${roomTypeId}`, getApiConfig());
  return response.data;
};

